import { SET_USER, CLEAR_USER } from '../Action/user';

const initialState = {
  userData: null,
};

const userReducer1 = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        userData: action.payload,
      };
    case CLEAR_USER:
      return {
        ...state,
        userData: null,
      };
    default:
      return state;
  }
};

export default userReducer1;
